import React, { useContext } from 'react';
import { Box, Optional } from '@honda-canada/design-system-react';

import FooterContext from '../service/FooterContext';
import GeoLocator from '../shared/GeoLocator';
import LanguageLinks from '../shared/LanguageLinks';
import SocialMediaLinks from '../shared/SocialMediaLinks';
import themeStyles from '../Footer.styles';

const Row = themeStyles.apply(Box, 'Row');
const Column = themeStyles.apply(Box, 'Column');
const SecondaryContainer = themeStyles.apply(Box, 'SecondaryContainer');

const MenuSecondary = () => {
  const {
    socialMediaSection,
    socialMenuAtSecondary,
    locationAtSecondary,
    languageAtSecondary,
    showGeoLocator,
    styles,
  } = useContext(FooterContext);

  return (
    <Optional when={socialMenuAtSecondary || (locationAtSecondary && showGeoLocator) || languageAtSecondary}>
      <SecondaryContainer styles={styles.secondaryContainer}>
        <Row noWrap>
          <Optional when={socialMenuAtSecondary}>
            <Column noFlex>
              <SocialMediaLinks alignment="left" data={socialMediaSection} />
            </Column>
          </Optional>
          <Optional when={locationAtSecondary && showGeoLocator}>
            <Column noFlex>
              <GeoLocator />
            </Column>
          </Optional>
          <Optional when={languageAtSecondary}>
            <Column noFlex ml="auto" display="flex">
              <LanguageLinks />
            </Column>
          </Optional>
        </Row>
      </SecondaryContainer>
    </Optional>
  );
};

export default MenuSecondary;
